import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.info');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import { Router } from '@angular/router'
import { marked } from 'marked';

@Component({
    selector: 'wiz-portal-gsdcadmin-community-info',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.info/view.scss */
/* src/app/portal.gsdcadmin.community.info/view.scss: no such file or directory */`],
})
export class PortalGsdcadminCommunityInfoComponent implements OnInit, OnDestroy {
    @ViewChild('editor')
    public editorElement: ElementRef;
    public editor: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() community_id: any;
    public community: any = {};

    public managers: any = [];
    public selectedManagerId: string | number | null = null;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.buildEditor();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { id: this.community_id });
        if (code != 200) return window.location = "/dashboard";
        this.community = data.community;
        this.groupTotal = data.groupTotal;

        this.managers = data.managers;
        const current = this.managers.find((m: any) => m?.designation === 'Y');
        this.selectedManagerId = current?.id ?? null;

        await this.service.render();
    }

    public onManagerMouseDown(user: any) {
        this.prevSelectedManagerId = this.selectedManagerId;
    }

    public async changeManager(user: any) {
        const prevId = this.prevSelectedManagerId;

        const ok = await this.service.alert.success("정말 변경하시겠습니까?", "취소");
        if (!ok) {
            this.selectedManagerId = prevId;   // ✅ 원복
            await this.service.render();
            return;
        }

        const { code } = await wiz.call("changeManger", { user_id: user.id, community_id: this.community_id });
        if (code !== 200) {
            this.selectedManagerId = prevId;   // ✅ 실패 시도 원복
            await this.service.render();
            return await this.service.alert.error("변경에 실패했습니다.");
        }

        // 성공 시 designation도 같이 정리(화면/데이터 일치)
        this.managers.forEach((m: any) => (m.designation = (m.id === user.id ? 'Y' : 'N')));
        await this.service.alert.success("변경되었습니다.");
        await this.service.render();
    }

    public async buildEditor() {
        if (this.community.description == null) this.community.description = "";
        let editor = this.editor = await ClassicEditor.create(this.editorElement.nativeElement, {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                shouldNotGroupWhenFull: true
            },
            codeBlock: {
                languages: [
                    { language: 'plaintext', label: '평문' },
                    { language: 'c', label: 'C' },
                    { language: 'cpp', label: 'C++' },
                    { language: 'cs', label: 'C#' },
                    { language: 'css', label: 'CSS' },
                    { language: 'diff', label: 'Diff' },
                    { language: 'html', label: 'HTML' },
                    { language: 'java', label: 'Java' },
                    { language: 'javascript', label: 'JavaScript' },
                    { language: 'markdown', label: 'Markdown' }, // 여기서 Markdown 추가
                    { language: 'php', label: 'PHP' },
                    { language: 'python', label: 'Python' },
                    { language: 'ruby', label: 'Ruby' },
                    { language: 'typescript', label: 'TypeScript' },
                    { language: 'xml', label: 'XML' }
                ]
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });
        this.editor.data.set(this.community.description);
    }

    public async ngOnDestroy() {
        this.community.description = this.editor.getData();
    }

    public async update() {
        if (this.tab == 'text') this.changeTab('editor')
        this.community.description = this.editor.getData();
        if (this.community.name == "") return await this.service.alert.error("연구커뮤니티 명을 입력해주세요.");
        else if (!('regist_pi' in this.community)) return await this.service.alert.error("PI 승인 절차를 선택해주세요.");
        else if (!('regist_user' in this.community)) return await this.service.alert.error("개인 연구자 승인 절차를 선택해주세요.");
        const { code } = await wiz.call("update", this.community);
        if (code != 200) await this.service.alert.error("오류가 발생했습니다.");
        let res = await this.service.alert.success("저장되었습니다.");
        if (res && !('id' in this.community)) await this.router.navigate(['/admin/community']);
        await this.service.render();
    }

    public tab: 'editor' | 'text' = 'editor';

    public async changeTab(tab: 'editor' | 'text') {
        if (!this.editor) {
            this.tab = tab;
            await this.service.render();
            return;
        }

        if (this.tab === 'editor' && tab === 'text') this.community.description = this.editor.getData();
        if (this.tab === 'text' && tab === 'editor') this.editor.setData(this.community.description || '');

        this.tab = tab;
        await this.service.render();
    }
}

export default PortalGsdcadminCommunityInfoComponent;